<!--
 * @title: 页面名称
 * @Description: 
 * @Version: 2.0
 * @Autor: 研发三部
 * @Date: 2020-12-03 09:37:11
 * @LastEditors: jinzb
 * @LastEditTime: 2020-12-28 16:01:28
-->
<template>
    <div class="content3">
        <div class="block1">
            <span class="resource-title">
                <!-- <i class="el-icon-minus title_icon"></i> -->
                <span
                    style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 3%;">▎</span>有害生物名录</span>
            <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height:100%">
                <div style="margin: 0 5%;height: 100%;">
                    <div style="height:  4%;"></div>
                    <div style="display: flex;height: 93%;flex-direction: column;">
                        <div style="height: 50%;" v-if="pestListTable1.data.length>0">
                        <span class="pest_title" style="">鼠害名录</span>
                        <div style="width: 100%;height: 100%;">
                            <dv-scroll-board :config="pestListTable1" style="width:100%;height:80%" />

                        </div>

                    </div>
                    <div style="height: 50%;" v-if="pestListTable2.data.length>0">
                        <span class="pest_title">虫害名录</span>
                        <dv-scroll-board :config="pestListTable2" style="width:100%;height:80%" />
                    </div>

                    <div style="height: 50%;" v-if="pestListTable3.data.length>0">
                        <span class="pest_title">毒害草名录</span>
                        <dv-scroll-board :config="pestListTable3" style="width:100%;height:80%" />
                    </div>

                    <div style="height: 50%;" v-if="pestListTable4.data.length>0">
                        <span class="pest_title">病害名录</span>
                        <dv-scroll-board :config="pestListTable4" style="width:100%;height:80%" />
                    </div>
                       
                    </div>
                    <!-- <div style="height: 31%;">
                        <span class="pest_title" style="">鼠害名录</span>
                        <div style="width: 100%;height: 100%;">
                            <dv-scroll-board :config="pestListTable1" style="width:100%;height:80%" />

                        </div>

                    </div>
                    <div style="height: 31%;">
                        <span class="pest_title">虫害名录</span>
                        <dv-scroll-board :config="pestListTable2" style="width:100%;height:80%" />
                    </div>

                    <div style="height: 31%;">
                        <span class="pest_title">毒害草名录</span>
                        <dv-scroll-board :config="pestListTable3" style="width:100%;height:80%" />
                    </div> -->
                </div>

            </dv-border-box-1>
        </div>
        <div class="block2">
            <div style="display: flex;
    justify-content: space-around;height:65%;">
                <div style="width: 65%;" class="image_block">

                    <div style=" height:100%;width: 100%;border-radius: 10px;">

                        <el-carousel :interval="6000" arrow="always" style="height: 100%">
                            <el-carousel-item v-for="item in mapImages" style="height: 100%">
                                <div class="image_title"></div>
                                <div style="width: 100%; height: 90%;position: relative;">

                                    <el-image class="imageBox7" :preview-src-list="mapImages.map(ele=> ele.url)" :src=" item.url" fit="contain"
                                        style="width: 100%; height: 100%;">

                                    </el-image>

                                    <div style="position: absolute;top: -9%;left:  40%;" class="image_title"> {{ item.name
                                    }} </div>



                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
                <div style="width: 35%;">
                    <span class="resource-title">
                        <!-- <i class="el-icon-minus title_icon"></i> -->
                        <span
                            style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1vw;margin-left: 3%;">▎</span>各县调查数据</span>
                    <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height:100%">
                        <div style="margin: 0 5%; height: 30%;">
                            <div
                                style="padding-top: 2%;margin-left: 2.5%;height: 40%;width:100%;color: #fff;font-size: 1vw;display: flex;align-items: center;">
                                <div> 有害生物调查标准地数量：{{ sum }}个</div>
                            </div>
                            <div style="height: 60%;width:100%;" v-if="config1Flag">
                                <dv-scroll-board :config="config1" style="width:100%;height:100%" />
                            </div>

                        </div>
                        <!-- <centerLeft1 /> -->
                        <div style="margin: 0 5%;height: 70%;">
                            <div style="height: 100%;">

                                <div style="
                height: 14%;
                font-size: 1vw;
                color: #fff;
                position: relative;
                top: 0px;
                left: 0px;">
                                    <div style="
                  height: 100%;
                  position: absolute;
                  top: 0%;
                  left: 3%;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  flex-direction: column;">
                                        <div style="height: 100%">
                                            各县标准地分布情况
                                        </div>
                                    </div>
                                </div>

                                <div style="height: 86%;">
                                    <v-chart :option="pestInfoChart" autoresize style="width:100%;height:100%" />
                                </div>
                            </div>
                        </div>
                    </dv-border-box-1>
                </div>
            </div>
            <div style="height: 35%;">
                <div style="width: 100%;height: 100%;">
                    <div class="resource-title">
                        <!-- <i class="el-icon-minus title_icon"></i> -->
                        <span
                            style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 1%;">▎</span>过程展示
                    </div>
                    <div style="height: 100%;" class="bottom_image">
                        <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: 100%;">
                            <div style="width:100%;height: 90%;display: flex;
    justify-content: space-around; ">
                                <div style="margin-left: 2%;width: 22%;height:100%;text-align: center;">
                                    <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                                        <el-carousel-item v-for="item in professionalImage" style="height: 100%;">
                                            <el-image class="imageBox3" :src=" item.url" fit="fit"
                                                style="width: 100%;height: 100%;margin-top: 10%;"
                                                @click="handlePictureCardPreview(item.url)"></el-image>
                                            <!-- <div style="position: absolute;top: 0;left: 0;font-size: 1vw;color: red;"> h:{{
                                                h }};w:{{ w }}</div> -->
                                        </el-carousel-item>
                                    </el-carousel>
                                    <div class="pest_image_title">工作照</div>
                                </div>
                                <div style="width: 22%;height:100%;text-align: center;">
                                    <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                                        <el-carousel-item v-for="item in habitatImage" style="height: 100%;">
                                            <el-image :src=" item.url" fit="fit"
                                                style="width: 100%;height: 100%;margin-top: 10%;"
                                                @click="handlePictureCardPreview(item.url)"></el-image>
                                        </el-carousel-item>
                                    </el-carousel>
                                    <div class="pest_image_title">生境照</div>
                                </div>
                                <div style="width: 22%;height:100%;text-align: center;">
                                    <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                                        <el-carousel-item v-for="item in speciesImage" style="height: 100%;">
                                            <el-image :src=" item.url" fit="fit"
                                                style="width: 100%;height: 100%;margin-top: 10%;"
                                                @click="handlePictureCardPreview(item.url)"></el-image>
                                        </el-carousel-item>
                                    </el-carousel>
                                    <div class="pest_image_title">种类照</div>
                                </div>
                                <div style="margin-right: 2%;width: 22%;height:100%;text-align: center;">
                                    <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                                        <el-carousel-item v-for="item in specimenImage" style="height: 100%;">
                                            <el-image :src=" item.url" fit="fit"
                                                style="width: 100%;height: 100%;margin-top: 10%;"
                                                @click="handlePictureCardPreview(item.url)"></el-image>
                                        </el-carousel-item>
                                    </el-carousel>
                                    <div class="pest_image_title">标本照</div>
                                </div>

                            </div>
                        </dv-border-box-1>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" @close="closeDialogImage" modal-append-to-body append-to-body>
            <div style="position: relative;" class="image_dialog">
                <img width="100%" :src=" dialogImageUrl" alt="" />
                <el-button class="closeButton" style="z-index: 10;" circle @click="closeDialogImage">
                    <i class="el-icon-close"></i>
                </el-button>

            </div>

        </el-dialog>

    </div>
</template>
<script>

import leftTop from "../comp/shouye/leftTop.vue";
import leftBottom from "../comp/shouye/leftBottom.vue";
import rightBottom from "../comp/shouye/rightBottom.vue";
import rightTop from "../comp/shouye/rightTop.vue";

import CFG from "@/config/config";
import * as api from "@/api/cloud-screen";


export default {
    components: { leftTop, leftBottom, rightBottom, rightTop },
    props: {
        show: {
            type: Boolean,
            default: true
        },
        maptype: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            w: 0,
            h: 0,
            w1: 0,
            h1: 0,
            urlprefix: CFG.LOTIP,
            dialogImageUrl: '',
            dialogVisible: false, //预览是否可见


            sum: "-",
            config1Flag:false,
            config1: {
                header: ['虫害', '鼠害', '毒害草','病害'],
                data: [

                ],
                headerBGC: "rgba(22, 83, 77,0)",
                oddRowBGC: "rgba(22, 83, 77,0)",
                evenRowBGC: "rgba(22, 83, 77,0)",
                align:[]
            },
            mapImages: [],
            professionalImage: [],
            habitatImage: [],
            speciesImage: [],
            specimenImage: [],
            pestInfoChartX: [],
            pestInfoChartY: [],
            pestInfoChartIndex: 5,
            pestInfoChartInterval: null,
            pestInfoChart: {
                // 全局调色盘。
                // title: {
                //     text: '各县标准地分布情况',
                //     left: "10",
                //     top: "0",
                //     textStyle: {
                //         color: '#fff',
                //     }
                // },
                legend: {
                    show: false
                },
                grid: {
                    left: "20px",
                    right: "20px",
                    bottom: "20px",
                    top: "30px",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    formatter: "{b}:{c0}个"
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        interval: 0,
                        show: true,
                        rotate: 20,
                        textStyle: {
                            color: "#fff"
                        },
                        align: 'center',
                        margin: 20,
                        fontSize: 11
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                dataZoom: {
                    show: true,
                    realtime: true,
                    start: 0,
                    type: "inside",
                    end: 100,
                    backgroundColor: "rgba(19,227,227,0.3)"
                },

                yAxis: {
                    name: "个",
                    type: "value",
                    splitLine: { show: false },
                    axisLabel: {
                        show: "true",
                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },

                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    },
                    axisTick: {
                        show: false // 是否显示刻度线
                    },
                    axisLabel: {
                        show: false // 是否显示刻度标签
                    },
                    nameTextStyle: {
                        fontSize: 14,
                        fontWeight: 800
                    },
                },
                series: {
                    data: [], //this.dataSource.ydata[0].data,
                    type: "bar",
                    barWidth: "50%",
                    label: {
                        show: true,
                        position: "top",
                        color: "#fff"
                    },
                    itemStyle: {
                        //  color: "#0099FF",

                        normal: {
                            // 随机显示
                            // color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}

                            // 定制显示（按顺序）
                            color: function (params) {
                                var colorList = [
                                    "#82FDF3",
                                    "#69A3F7",
                                    "#3874FC",
                                    "#3450FB",
                                    "#755EFB",
                                    "#B657FC",
                                    "#BC4FFB", "#8183E0", "#2691CF", "#4FC7EA", "#9EAAD7", "#BEE8FF", "#00C5FF", "#00A9E6", "#9EBBD7", "#BED2FF", "#73B2FF", "#73DFFF", "#7A8EF5", "#6677CD", "#E8BEFF", "#FFBEE8"
                                ];
                                let colorItem = colorList[params.dataIndex];
                                return colorItem;
                            },
                            fontSize: 11
                        }
                    }
                }
            },

            pestListTable1: {
                header: ['科名', '属名', '种名'],
                data: [

                ],
                headerBGC: "rgba(14, 45, 40,0.8)",
                oddRowBGC: "rgba(14, 45, 40,0.59)",
                evenRowBGC: "rgba(14, 45, 40,0.59)",
                align:['center','center','center']
            },
            pestListTable2: {
                header: ['科名', '种名'],
                data: [

                ],
                headerBGC: "rgba(14, 45, 40,0.8)",
                oddRowBGC: "rgba(14, 45, 40,0.59)",
                evenRowBGC: "rgba(14, 45, 40,0.59)",
                align:['center','center']
            },
            pestListTable3: {
                header: ['科名', '属名', '种名'],
                data: [

                ],
                headerBGC: "rgba(14, 45, 40,0.8)",
                oddRowBGC: "rgba(14, 45, 40,0.59)",
                evenRowBGC: "rgba(14, 45, 40,0.59)",
                align:['center','center','center']
                // rowNum:4
            },

            pestListTable4: {
                header: ['科名', '种名'],
                data: [

                ],
                headerBGC: "rgba(14, 45, 40,0.8)",
                oddRowBGC: "rgba(14, 45, 40,0.59)",
                evenRowBGC: "rgba(14, 45, 40,0.59)",
                align:['center','center']
                // columnWidth:35
            },

        };
    },
    async mounted() {
        // setInterval(() => {
        //     this.getH()
        //     this.getW()
        //     this.getH1()
        //     this.getW1()
        // }, 5000);
        console.log(this.$route.query);
        console.log(this.$route.params.systemSid);

        console.log(this.conf, "conf=================");

        let data = await api.getConfig(this.$route.params.systemSid);
        console.log(data, "mmmmmmmmmmmm");
        if (data.resp_code == "10000") {
            this.conf = data.data;
        }

        // this.getAreaAndType();
        this.getPestInfoChart();

        this.getPestListTable();
        this.getPestInfoCount();
        // this.getVegetationCoverageChart();

        if (this.$route.query) {

            if (this.$route.query["biologicalMapImage"]) {
                this.mapImages = JSON.parse(this.$route.query["biologicalMapImage"]);
            } else {
                if (this.conf && this.conf["biologicalMapImage"]) {
                    this.mapImages = JSON.parse(this.conf["biologicalMapImage"]);
                } else {
                    this.mapImages = [];
                }
            }

            if (this.$route.query["professionalImage"]) {
                this.professionalImage = JSON.parse(this.$route.query["professionalImage"]);
            } else {
                if (this.conf && this.conf["professionalImage"]) {
                    this.professionalImage = JSON.parse(this.conf["professionalImage"]);
                } else {
                    this.professionalImage = [];
                }
            }

            if (this.$route.query["habitatImage"]) {
                this.habitatImage = JSON.parse(this.$route.query["habitatImage"]);
            } else {
                if (this.conf && this.conf["habitatImage"]) {
                    this.habitatImage = JSON.parse(this.conf["habitatImage"]);
                } else {
                    this.habitatImage = [];
                }
            }

            if (this.$route.query["speciesImage"]) {
                this.speciesImage = JSON.parse(this.$route.query["speciesImage"]);
            } else {
                if (this.conf && this.conf["speciesImage"]) {
                    this.speciesImage = JSON.parse(this.conf["speciesImage"]);
                } else {
                    this.speciesImage = [];
                }
            }

            if (this.$route.query["specimenImage"]) {
                this.specimenImage = JSON.parse(this.$route.query["specimenImage"]);
            } else {
                if (this.conf && this.conf["specimenImage"]) {
                    this.specimenImage = JSON.parse(this.conf["specimenImage"]);
                } else {
                    this.specimenImage = [];
                }
            }

        } else {
            if (this.conf) {

                if (this.conf["biologicalMapImage"]) {
                    this.mapImages = JSON.parse(this.conf["biologicalMapImage"]);
                } else {
                    this.mapImages = [];
                }

                if (this.conf["professionalImage"]) {
                    this.professionalImage = JSON.parse(this.conf["professionalImage"]);
                } else {
                    this.professionalImage = [];
                }

                if (this.conf["habitatImage"]) {
                    this.habitatImage = JSON.parse(this.conf["habitatImage"]);
                } else {
                    this.habitatImage = [];
                }

                if (this.conf["speciesImage"]) {
                    this.speciesImage = JSON.parse(this.conf["speciesImage"]);
                } else {
                    this.speciesImage = [];
                }

                if (this.conf["specimenImage"]) {
                    this.specimenImage = JSON.parse(this.conf["specimenImage"]);
                } else {
                    this.specimenImage = [];
                }
            }
        }

        console.log(this.mapImages, "==============")
    },
    methods: {
        getW() {
            this.w = document.getElementsByClassName('imageBox3')[0].clientWidth
        },

        getH() {
            this.h = document.getElementsByClassName('imageBox3')[0].clientHeight
        },
        getW1() {
            this.w1 = document.getElementsByClassName('imageBox7')[0].clientWidth
        },

        getH1() {
            this.h1 = document.getElementsByClassName('imageBox7')[0].clientHeight
        },
        handlePictureCardPreview(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true;
        },
        closeDialogImage() {
            this.dialogImageUrl = "";
            this.dialogVisible = false;
        },

        getPestInfoChart() {
            api.getPestInfoChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    // this.pestInfoChart.xAxis.data = res.data.x;
                    // this.pestInfoChart.series.data = res.data.y;
                    if (res.data.x.length > 6) {
            this.pestInfoChartX = res.data.x;
            this.pestInfoChartY = res.data.y;
            this.pestInfoChart.xAxis.data = res.data.x.slice(0, 6);
            this.pestInfoChart.series.data = res.data.y.slice(0, 6);
            this.pestInfoChartInterval = setInterval(this.chagePestInfoChart, 3500)

          } else {
            this.pestInfoChart.xAxis.data = res.data.x;
            this.pestInfoChart.series.data = res.data.y;
          }

                }
            });
        },
        chagePestInfoChart(){
            console.log("chagePestInfoChart")
      this.pestInfoChartIndex = this.pestInfoChartIndex + 1 > this.pestInfoChartX.length - 1 ? 0 : this.pestInfoChartIndex + 1
      this.pestInfoChart.xAxis.data.shift();
      this.pestInfoChart.series.data.shift();
      this.pestInfoChart.xAxis.data.push(this.pestInfoChartX[this.pestInfoChartIndex]);
      this.pestInfoChart.series.data.push(this.pestInfoChartY[this.pestInfoChartIndex]);
        },
        getPestInfoCount() {
            this.config1Flag=false
            api.getPestInfoCount(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    let obj = res.data.map;
                    this.sum = res.data.sum

                    let a=[]
                    let a1=[]
                    let a2=[]

                    if(obj['虫害']>0){
                        a.push("虫害")
                        a1.push(obj['虫害']+ '个')
                        a2.push('center')
                    }
                    if(obj['鼠害']>0){
                        a.push("鼠害")
                        a1.push(obj['鼠害']+ '个')
                        a2.push('center')
                    }
                    if(obj['毒害草']>0){
                        a.push("毒害草")
                        a1.push(obj['毒害草']+ '个')
                        a2.push('center')
                    }
                    if(obj['病害']>0){
                        a.push("病害")
                        a1.push(obj['病害']+ '个')
                        a2.push('center')
                    }

                    // let arr = [[obj['虫害'] + '个', obj['鼠害'] + '个', obj['毒害草'] + '个', obj['毒害草1'] + '个']]
                    // this.config1.data = arr
                    console.log(a)
                    console.log(a1)
                    this.config1.header = a
                    this.config1.data = [a1]
                    this.config1.align = a2
                    console.log(this.config1)
                    this.config1 = { ...this.config1 }
                    this.config1Flag=true
                }
            });
        },

        getPestListTable() {
            api.getPestListTable1(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    console.log(res)
                    this.pestListTable1.data = res.data['鼠害'];
                    this.pestListTable2.data = res.data['虫害'];
                    this.pestListTable3.data = res.data['毒害草'];
                    this.pestListTable4.data = res.data['病害'];
                    if(this.pestListTable1.data.length>0 && this.pestListTable2.data.length>0 && this.pestListTable3.data.length>0 && this.pestListTable4.data.length>0 ){
                        this.pestListTable1.rowNum=3
                        this.pestListTable2.rowNum=3
                        this.pestListTable3.rowNum=3
                        this.pestListTable4.rowNum=3
                    }

                    this.pestListTable1 = { ... this.pestListTable1 }
                   
                    this.pestListTable2 = { ... this.pestListTable2 }
                    
                    this.pestListTable3 = { ... this.pestListTable3 }
                    
                    this.pestListTable4 = { ... this.pestListTable4 }
                }
            });
            // api.getPestListTable(this.$route.params.systemSid, "虫害").then((res) => {
            //     if (res.resp_code == "10000") {
            //         this.pestListTable2.data = res.data.data;
            //         this.pestListTable2 = { ... this.pestListTable2 }
            //     }
            // });
            // api.getPestListTable(this.$route.params.systemSid, "毒害草").then((res) => {
            //     if (res.resp_code == "10000") {
            //         this.pestListTable3.data = res.data.data;
            //         this.pestListTable3 = { ... this.pestListTable3 }
            //     }
            // });
        },

    },
    beforeDestroy(){
    console.log("销毁")
    if(this.pestInfoChartInterval){
      clearInterval(this.pestInfoChartInterval); 
    }
    

  }
};
</script>
  
  
<style lang="scss"  scoped>
.image_dialog .closeButton {
    width: 45px;
    height: 45px;
    background-color: rgba(0, 0, 0, .4) !important;
    font-size: 1.5vw;
    font-weight: 600;
    position: absolute;
    top: 2%;
    right: 2%;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
}

/deep/ .el-dialog__header {
    padding: 0 0 !important;
}

/deep/ .el-dialog__body {
    padding: 0 0 !important;
}

.bottom_image /deep/ .el-carousel__indicators--horizontal {
    display: none;
}

.block2 /deep/ .dv-scroll-board .header .header-item {
    font-size: 1vw;
    // font-weight: 800;

}

.block2 /deep/ .row-item {
    height: 100% !important;
    line-height: 100% !important;
    color: #00fefe;
    font-size: 1vw;
    // font-weight: 800;
}

.pest_image_title {
    // display: inline-block;
    height: 10%;
    // line-height: 10%;
    color: #fff;
    font-size: 0.9vw;
    font-weight: 800;
    padding: 3% 0;
}

.pest_title {
    display: inline-block;
    height: 10%;
    line-height: 10%;
    color: #fff;
    font-size: 1vw;
    // font-weight: 800;
}

.content3 {
    //   display: flex;
    // justify-content: space-between;
    // background-color: pink !important;
    // display: grid !important;
    // grid-template-columns: 3fr 5fr  !important;
    display: flex;
    justify-content: space-around;
    // padding-top: 90px;
    height: calc(100% - 40px);
    // height: 100%;

    .block1 {
        height: 100%;
        width: 26%;

    }

    .block2 {
        height: 100%;
        width: 74%;

    }

}

.image_block /deep/ .el-carousel__arrow {
    font-weight: 800;
    font-size: 2vw;
    line-height: 2vw;
}

/deep/ .el-carousel__container {
    height: 100%;
}

.image_title {
    font-style: oblique;
    text-align: center;
    color: #fff;
    font-size: 1.5vw;
    height: 40px;
    line-height: 40px;
    font-weight: 500;
    text-shadow: 0 0 5px #000000, 0 0 5px #000000, 0 0 5px #000000;
}

.title_icon {
    transform: rotate(90deg);
    font-weight: 700;
    color: #00ffff;
}

.resource-title {
    color: #fff;
    font-size: 1.5vw;
    height: 40px;
    line-height: 40px;
    margin-top: 0px;
    font-weight: 500;
    text-shadow: 0 0 5px #000000, 0 0 5px #000000, 0 0 5px #000000;
}

.image_base {
    width: 100%;
    height: 100%;
    padding: 16px 16px 0 16px;
    background-image: url("../../../assets/large-screen-img/ditu.png");
    background-size: cover;
    background-position: center center;
}
</style>
  
<style >
.el-image-viewer__mask{
 opacity: 1 !important;
   background: #fff !important;
}
</style>